(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-week-additions/assets/javascripts/weeks.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-week-additions/assets/javascripts/weeks.js');
"use strict";

const _React = React,
  useCallback = _React.useCallback;
const BaseWeek = svs.components.tipsen.couponAdditionsComponents.Weeks;
const Weeks = () => {
  const presentableWeek = useCallback(numberOfWeeks => "".concat(numberOfWeeks, " veck").concat(numberOfWeeks > 1 ? 'or' : 'a'), []);
  return React.createElement(BaseWeek, {
    description: "V\xE4lj hur m\xE5nga veckor du vill spela din rad.",
    icon: "calendar-week",
    legend: "Antal veckor spelet ska p\xE5g\xE5",
    presentableWeek: presentableWeek,
    title: "Spela flera veckor"
  });
};
setGlobal('svs.components.tipsen.couponWeekAddition.Weeks', Weeks);

 })(window);